import VideoCard from "../videos/VideoCard";
import useEmblaCarousel from "embla-carousel-react";
import type { ProgramInterface } from "../../types/program.interface";
import { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { UserProgram } from "../../types/userProgram.interface";

interface Props {
  program: ProgramInterface,
  userProgram?: UserProgram;
}

export const VideosList = ({ program, userProgram }: Props) => (
  <>
    <div>
      {program?.weeks?.map((week, weekIndex: number) => {
        const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });
        const [prevEnabled, setPrevEnabled] = useState(false);
        const [nextEnabled, setNextEnabled] = useState(false);

        const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
        const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

        const onSelect = useCallback(() => {
          if (!emblaApi) return;
          setPrevEnabled(emblaApi.canScrollPrev());
          setNextEnabled(emblaApi.canScrollNext());
        }, [emblaApi]);

        useEffect(() => {
          if (!emblaApi) return;
          onSelect();
          emblaApi.on("select", onSelect);
        }, [emblaApi, onSelect]);


        return (
          <div key={weekIndex} className="mb-12">
            <h2 className="text-xl font-semibold mb-4">Videos de la semana {weekIndex + 1}</h2>
            <div className="relative">
              <div className="overflow-hidden" ref={emblaRef}>
                <div className="flex">
                  {week.map(({ video }) => {
                    const completed = userProgram?.completed.some(v => v.video === video._id) ?? false;
                    // TODO: pass in if its a day 1 day 2 video 
                    return (
                      <div
                        key={video._id}
                        className="min-w-[80%] sm:min-w-[50%] md:min-w-[calc(100%/3)] px-2 box-border"
                      >
                        <VideoCard video={video} completed={completed} />
                      </div>
                    )
                  })}
                </div>
              </div>

              <button
                onClick={scrollPrev}
                disabled={!prevEnabled}
                className={`absolute top-1/2 left-[-30px] transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md ${prevEnabled ? 'cursor-pointer' : 'opacity-30 cursor-default'
                  }`}
              >
                <ChevronLeft />
              </button>
              <button
                onClick={scrollNext}
                disabled={!nextEnabled}
                className={`absolute top-1/2 right-[-30px] transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md ${nextEnabled ? 'cursor-pointer' : 'opacity-30 cursor-default'
                  }`}
              >
                <ChevronRight />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </>
)